import gql from 'graphql-tag';

export default gql`
  mutation removeByIdFormTemplateMutation($_id: MongoID!) {
    removeByIdFormTemplateMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
